import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material"
import moment from "moment"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { createExtapies, getInventory, getOrganizationData } from "../../../services/api"
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component"
import { FilterBy } from "../../commons/filter.component"
import CustomDatePicker from "../../commons/CustomDatePicker"

const CreateExtapies = ({ open, onClose, onCreateResponse }) => {
    const [t] = useTranslation()
    const [input, setInput] = useState({
        organization: null,
        inventory: null,
        url: '',
        account: '',
        password: '',
        sync_at: ''
    })
    // method
    const handleCreate = () => {
        return createExtapies({
            organization_id: input.organization?.id,
            inventory_id: input.inventory?.id,
            url: input.url,
            account: input.account,
            password: input.password,
            sync_at: moment(input.sync_at).format('YYYY-MM-DD')
        })
    }
    // effect

    return (
        <Dialog open={Boolean(open)} onClose={onClose}>
            <DialogTitle align='center'>
                {t('Nhập thông tin kết nối kho đầu nguồn')}
            </DialogTitle>
            <DialogContent>
                <div style={{ display: 'grid', rowGap: 10, marginTop: 10 }}>
                    <FilterBy style={{ display: 'inline-flex', minWidth: 240 }}
                        getDataFunc={() => getOrganizationData({ status: 1 })}
                        value={input.organization || null}
                        onChange={(e, newValue) => setInput(prev => ({ ...prev, organization: newValue }))}
                        label={t('Tổ chức')}
                    />
                    <FilterBy style={{ display: 'inline-flex', minWidth: 240 }}
                        getDataFunc={() => getInventory({ status: 1 })}
                        value={input.inventory || null}
                        onChange={(e, newValue) => setInput(prev => ({ ...prev, inventory: newValue }))}
                        label={t('Kho hàng')}
                    />
                    <TextField fullWidth
                        label={t('URL')}
                        value={input.url}
                        onChange={e => setInput(prev => ({ ...prev, url: e.target.value }))}
                    />
                    <TextField fullWidth
                        label={t('Tài khoản')}
                        value={input.account}
                        onChange={e => setInput(prev => ({ ...prev, account: e.target.value }))}
                    />
                    <TextField fullWidth type='password' autoComplete='new-password'
                        label={t('Mật khẩu')}
                        value={input.password}
                        onChange={e => setInput(prev => ({ ...prev, password: e.target.value }))}
                    />
                    <CustomDatePicker format='DD/MM/YYYY'
                        label={t('Thời gian đồng bộ')}
                        value={input.sync_at}
                        onChange={value => setInput(prev => ({ ...prev, sync_at: value }))}
                        sx={{ width: '100%' }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Hủy')}</Button>
                <ButtonWithAPICall
                    variant='contained'
                    api={handleCreate}
                    response={onCreateResponse}
                >
                    {t('Tạo mới')}
                </ButtonWithAPICall>
            </DialogActions>
        </Dialog>
    )
}

export default CreateExtapies